// This file contains the types and interfaces used in the QLE module

interface IQLEVerificationDocumentResponse {
    applicationId: string;
    status: string;
    validationStatus: VALIDATION_STATUS;
    eligibilityStatus: string;
    financialAssistanceFlag: 'Y' | 'N';
    applicants: IQLEApplicants[];
}

interface IQLEApplicants {
    firstName: string;
    lastName: string;
    middleName: string;
    personId: number;
    applicantId: number;
    eligibilityStatus: string;
    events: IQLEEvents[];
}

interface IQLEEvents {
    applicantEventId: string;
    eventLabel: string;
    eventName: string;
    eventDate: string;
    eventCategoryLabel: string | null;
    eventCategory: string;
    changeType: string;
    displayOnUi: string;
    type: number;
    isPlanSelectionAllowed: string;
    eventId: string;
    uploadedDocumentList: any[];
    validationStatus: VALIDATION_STATUS;
    validDocumentList: any | null;
}

enum VALIDATION_STATUS {
    'INITIAL' = 'INITIAL',
    'PENDING' = 'PENDING',
    'SUBMITTED' = 'SUBMITTED',
    'REJECTED' = 'REJECTED',
    'NOT_REQUIRED' = 'NOTREQUIRED',
    'CANCELLED' = 'CANCELLED',
    'VERIFIED' = 'VERIFIED',
    'OVERRIDDEN' = 'OVERRIDDEN',
}

export { VALIDATION_STATUS, IQLEVerificationDocumentResponse, IQLEApplicants, IQLEEvents };
